import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumberYMD, plusDays, stringYMDHMS3 } from "../Utility/dateTime";
import TimeContainer from "./TimeContainer";
import { fetchCheckIn, updateCheckIns, updateEndDate, updateStartDate } from "../redux/checkInSlice";



function TimeControlCheckIn() {
    const dispatch = useDispatch()
    const { shop:{ shopId } } = useSelector((state)=> state.shop);

    const { billDates, model_CheckIn, startDate, endDate } = useSelector((state)=> state.checkIn);

    useEffect(()=>{
        if(billDates.length===0){
            search()
        }
    },[])


    function search(){
        let rewSearch = []
        let newSearch = []
        let start = startDate
        do {
            rewSearch.push(stringYMDHMS3(start))
            start = plusDays(start,1)
        }
        while (NumberYMD(start) <= NumberYMD(endDate));

        for(const item of rewSearch){
            if(!billDates.includes(item)){
                newSearch.push(item)
            }
        }
        
        if(newSearch.length >0){ //มีต้อง fetch เพิ่ม
            dispatch(fetchCheckIn({
                shopId,
                billDate:newSearch,
                selectedDate:rewSearch 
            }))
        } else {
            dispatch(updateCheckIns({ selectedDate:rewSearch }))
        }
    }

  return <TimeContainer
            search={search}
            show={model_CheckIn}
            startDate={startDate}
            endDate={endDate}
            onChangeStart={(date) => dispatch(updateStartDate(date))}
            onChangeEnd={(date) => dispatch(updateEndDate(date))}
        />
};


export default TimeControlCheckIn;
